import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

@Injectable()
export class ButtonStateService {

  public value: BehaviorSubject<string>;
  public dropdownState: ReplaySubject<string>;
  constructor() {
    this.dropdownState = new ReplaySubject();
    this.value = new BehaviorSubject('-24h');
  }

  setDropdownState(state) {
    // if (this.dropdownState.getValue() !== state) {
    this.dropdownState.next(state);
    // }
  }
  setButtonState(state) {
    if (this.value.getValue() !== state) {
      this.value.next(state);
    }
    return this; // for chaining
  }

}
